module.exports = __webpack_public_path__ + "img/badge-check.42fb381.svg";